import { render, staticRenderFns } from "./ConfigCost.vue?vue&type=template&id=5843552f&scoped=true&"
import script from "./ConfigCost.vue?vue&type=script&lang=js&"
export * from "./ConfigCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843552f",
  null
  
)

export default component.exports